import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum LocationType {
    ROOT = 'ROOT',
    BRANCH = 'BRANCH',
    LEAF = 'LEAF',
    SECTION = 'SECTION',
}

export const LOCATIONS_LIMIT = 500;

@JsonObject()
export default class Location {
    constructor(
        @JsonProperty({ required: true }) readonly id: number,
        @JsonProperty({ required: true }) readonly key: string,
        @JsonProperty({ required: true }) readonly name: string,
        @JsonProperty({ required: true }) readonly type: LocationType,
        @JsonProperty({
            required: false,
            beforeDeserialize: (value) => value.map((v: Tag) => v?.key),
            afterSerialize: (value) => value.map((v: Tag) => v?.key),
        })
        readonly tags: string[],
        @JsonProperty({ required: false, type: Location }) readonly children: Location[]
    ) {}
}

class Tag {
    constructor(readonly key: string) {}
}

@JsonObject()
export class LocationLinkCSV {
    constructor(
        @JsonProperty({ required: true }) readonly name: string,
        @JsonProperty({ required: true }) readonly linkedUrl: string,
        @JsonProperty({ required: true }) readonly type: LocationType
    ) {}
}
